import Vue from 'vue';
import VueYoutube from 'vue-youtube';


import NoSsr from '@/components/utils/no-ssr';

import App from './App.vue';

import { createRouter } from './router';
import { createStore } from './store/';
import './assets/styl/main.styl';

const mdpConfig = require('../mdp.config');

const domTemp = document.body.querySelector('#app-wrapper .content');
// console.info('domTemp', domTemp);
const articles = domTemp.querySelectorAll('.lc-product');
window.products = {};
for (let i = 0; i < articles.length; i += 1) {
  const id = articles[i].getAttribute('id');
  window.products[id] = {};
  window.products[id].linkElement = articles[i].querySelector('.product-link');
  window.products[id].priceElement = articles[i].querySelector('.price');
}
Object.keys(mdpConfig.attributes).forEach((attribute) => {
  window[`___${attribute}`] = domTemp.getAttribute(attribute);
});

const tokens = require('@/assets/tokens/tokens.json');

Vue.prototype.$tokens = Vue.$tokens = tokens; //eslint-disable-line
Vue.component('NoSsr', NoSsr);
Vue.use(VueYoutube);
Vue.filter('joinPath', paths => paths.join('/').replaceAll(/(https?:\/\/)|(\/)+/g, '$1$2'));

Vue.directive('visible', (el, binding) => {
  el.style.visibility = binding.value ? 'visible' : 'hidden'; // eslint-disable-line
});

export function createApp(version = 'fr') { // eslint-disable-line
  const router = createRouter(version);
  const store = createStore();
  const app = new Vue({
    router,
    store,
    render: h => h(App),
  });

  return { app, router, store };
}
